import { writable, derived } from 'svelte/store';
export const user = writable(null);
export const sid = writable("");
export const isUserLoggedIn = derived(user, $u => $u != null);
export const isUserRoleADM = derived(user, $u => ($u === null || $u === void 0 ? void 0 : $u.roles) && $u.roles.find(x => x === 'ADM') !== undefined);
export const isUserRoleOPR = derived(user, $u => ($u === null || $u === void 0 ? void 0 : $u.roles) && $u.roles.find(x => x === 'OPR') !== undefined);
